
import {Vue, Component} from 'vue-property-decorator';

@Component
export default class Redirect extends Vue {
  private created() {
    const { params, query } = this.$route;
    const { path } = params;
    this.$router.replace({path: '/' + path, query});
  }
  private render() {
    // 为了浏览器不报错，保留此函数
  }
}
